// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__35Gci","bigColWidth":"Table_bigColWidth__1K1XM","biggerColWidth":"Table_biggerColWidth__3C7Uh","row":"Table_row__U1qwy","col":"Table_col__2ixEp"};